import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'

export const state = () => ({
  isStale: true,
  latest_fetch: '',
  type: 'trophyrooms',
  pageLayout: 'LayoutStructureTable',
  canEdit: false,
  canView: false,
  inlineEdit: true,
  modelLabels: {
    single: 'Trophy Room',
    plural: 'Trophy Rooms'
  },
  filterOverrides: [],
  aliasField: 'title',
  relations: [
    {
      name: 'files',
      translate: 'files',
      label: 'files',
      value: 'files',
      storename: 'files',
      export: false
    }
  ],
  all: {},
  active: false,
  searchFields: ['title', 'subtitle', 'description'],
  bound: {
    title: ''
  },
  filter: {},
  quickFilters: [],
  stub: { files: {} },
  include: ''
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
